import {
  CreateShippingRateTableInputSchema,
  type ICreateShippingRateTableInput,
} from "@redotech/redo-conversion-core-common/redo-in-shipping/shipping-rate-table";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateShippingMethod = {
  name: "updateShippingMethod" as const,
  input: z.object({
    checkoutExperienceId: zExt.objectId(),
    shippingMethodId: zExt.objectId(),
    shippingRateTable:
      CreateShippingRateTableInputSchema as ICreateShippingRateTableInput,
  }),
  output: z.null(),
};
export type UpdateShippingMethodInput = z.infer<
  typeof updateShippingMethod.input
>;
